import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { UiEnvelopeEdit } from '@vyaguta/vyaguta-icons/ui';

import config from 'config';
import { INITIAL_OPEN_DELAY } from 'constants/appConstants';

interface AskUsAnythingProps {
  initialOpen?: boolean;
}

const AskUsAnything: React.FC<AskUsAnythingProps> = ({ initialOpen }) => {
  const [isInitiallyOpen, setIsInitiallyOpen] = useState<boolean>(true);

  useEffect(() => {
    if (!initialOpen) {
      return;
    }

    const timer = setTimeout(() => {
      setIsInitiallyOpen(false);
    }, INITIAL_OPEN_DELAY);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="ask-us-anything">
      <a href={config.askUsAnythingForm} target="_blank" rel="noopener noreferrer">
        <div
          className={classNames('d-flex align-items-center content', {
            'content--show': initialOpen && isInitiallyOpen,
          })}
        >
          <span className={classNames('label', { 'label--show': initialOpen && isInitiallyOpen })}>
            Ask Us Anything
          </span>
          <div className="icon d-flex align-items-center">
            <UiEnvelopeEdit size={16} />
          </div>
        </div>
      </a>
    </div>
  );
};

export default AskUsAnything;
